import { title } from "src/components/authentication/assets/jss/labs.js";

const productStyle = {
  section: {
    padding: "70px 0",
    textAlign: "center",
  },
  title: {
    ...title,
    marginBottom: "1rem",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
    color: "#FFFFF"
  },
  description: {
    color: "#FFFFF",
  },
};

export default productStyle;
